import React, { useState } from "react";
import { useSite } from "@/lib/site";

/**
 * CafLogo
 * Logo image + wordmark are admin-editable via Site Settings (/admin -> Site).
 * If site.logo_url is set, it is used; otherwise falls back to /logo.svg, then to a monogram.
 * variant: default | light
 */
export const CafLogo = ({ variant = "default", withWordmark = true, className = "" }) => {
  const site = useSite();
  const [imgOk, setImgOk] = useState(true);
  const light = variant === "light";
  const src = site.logo_url || "/logo-emblem.png";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <div className="relative h-11 w-11 shrink-0 rounded-full overflow-hidden ring-1 ring-[hsl(var(--orange))]/70">
        {imgOk ? (
          <img
            src={src}
            alt={`${site.org_name} logo`}
            className="h-full w-full object-cover"
            onError={() => setImgOk(false)}
            loading="eager"
          />
        ) : (
          <div className="h-full w-full bg-black grid place-items-center text-[hsl(var(--orange))] font-black text-sm">CAF</div>
        )}
      </div>
      {withWordmark && (
        <div className="flex flex-col leading-tight">
          <span className={`font-extrabold tracking-tight text-[14px] whitespace-nowrap ${light ? "text-white" : "text-foreground"}`} style={{ fontFamily: "Space Grotesk, sans-serif" }}>
            {site.org_name || "Citizen Awareness Foundation"}
          </span>
          <span className={`text-[9.5px] font-semibold uppercase tracking-[0.14em] whitespace-nowrap ${light ? "text-[hsl(var(--orange))]" : "text-[hsl(var(--green))]"}`}>
            {site.tagline || "Aware • Responsible • Together"}
          </span>
        </div>
      )}
    </div>
  );
};
